<template>
  <div class="toast-container-container" aria-live="polite">
    <div
      v-for="toast in $store.state.toasts"
      :key="toast"
      class="toast-container"
    >
      <div
        class="toast"
        :class="[toast.type, {fadeout: toast.fadeout}]"
        role="status"
        @animationend="handleAnim($event, toast.id)"
      >
        <b>{{ toast.title }}</b>
        <p v-if="toast.body">
          {{ toast.body }}
        </p>
      </div>
    </div>
    <div class="toast-container">
      <EligibilityNotice />
    </div>
  </div>
</template>

<script>
import EligibilityNotice from '@/components/EligibilityNotice.vue'

export default {
    components: {
        EligibilityNotice,
    },
    methods: {
        handleAnim (event, id) {
            if (event.animationName.startsWith('fadeout')) {
                this.$store.commit('deleteToast', id)
            }
        },
    },
}
</script>

<style lang="scss" scoped>
// TODO set up some better animations than just fade in and out, for example currently the whole list jumps up when a new toast appears

.toast-container-container {
    right: 0;
    margin-right: 1.5rem;
    bottom: 0;
    position: fixed;
    z-index: 300;
}

.toast-container {
    text-align: right;
}

// Minecraft's advancement toasts: a tooltip that slides in from the side,
// the title coloured by what happened.
.toast {
    @include mc-tooltip(0.96);
    display: inline-block;
    max-width: min(26rem, calc(100vw - 3rem));
    margin-bottom: 1.5rem;
    padding: 0.6rem 1rem;
    text-align: left;

    b {
        display: block;
        font-weight: 700;
        white-space: pre-wrap;
    }

    p {
        margin: 0.25rem 0 0;
        text-align: left;
        white-space: pre-wrap;
        color: $ssm-muted;
    }
    animation: fadein 0.4s steps(4, end);
}

.success {
    @include mc-frame($ssm-green);

    b {
        color: #55ff55;
    }
}

.error {
    @include mc-frame($ssm-redstone);

    b {
        color: #ff5555;
    }
}

.toast.fadeout {
    animation: fadeout 0.4s steps(4, end);
}

@keyframes fadein {
    from {
        opacity: 0;
        transform: translateX(110%);
    }
    to {
        opacity: 1;
        transform: none;
    }
}

@keyframes fadeout {
    from {
        opacity: 1;
        transform: none;
    }
    to {
        opacity: 0;
        transform: translateX(110%);
    }
}
</style>
